import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(filtro) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/finalizacoes?situacao=${filtro.situacao}&status=${filtro.status}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(finalizacaoId) {
        return axiosJwt
            .get(`${api}/credenciados/uabs/finalizacoes/${finalizacaoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFinalizacaoAnexo(finalizacaoAnexoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/finalizacoes/anexos/${finalizacaoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovarReprovarFinalizacao(aprovaReprovaFinalizacaoDto) {
        return axiosJwt
            .post(
                `${api}/credenciados/uabs/finalizacoes/aprovar`,
                aprovaReprovaFinalizacaoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    exportar(id) {
        let url = `${api}/credenciados/uabs/finalizacoes/${id}/exportar`
        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(finalizacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoId}/historico`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterCertidoes(finalizacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoId}/certidoes`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/credenciados/uabs/finalizacoes/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(finalizacaoId) {
        return axiosJwt
            .get(`${api}/credenciados/uabs/finalizacoes/${finalizacaoId}/anexos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirFinalizacaoAnexo(finalizacaoAnexo) {
        const formData = new FormData()
        formData.append('finalizacaoId', finalizacaoAnexo.finalizacaoId)
        formData.append('tipoId', finalizacaoAnexo.tipoId)
        formData.append('descritivo', finalizacaoAnexo.descritivo)
        formData.append('arquivo', finalizacaoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoAnexo.finalizacaoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(finalizacaoAnexo) {
        return axiosJwt
            .put(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoAnexo.finalizacaoId}/anexos`,
                finalizacaoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirPrioritario(finalizacaoId) {
        return axiosJwt
            .patch(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoId}/prioritario`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    definirEspecial(finalizacaoId) {
        return axiosJwt
            .patch(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoId}/especial`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(finalizacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoId}/timeline`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    retornarFinalizacao(finalizacaoId) {
        return axiosJwt
            .patch(
                `${api}/credenciados/uabs/finalizacoes/${finalizacaoId}/retornaruabs`
            )
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasReprovacao() {
        return axiosJwt
            .get(`${api}/credenciados/uabs/finalizacoes/reprovarpagamentoopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    },

    obterCategoriasAprovacaoJustificada() {
        return axiosJwt
            .get(`${api}/credenciados/uabs/finalizacoes/aprovacaojustificadaopcoes`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
